import {
  InstructorEventImpl,
  Instructorevents,
} from '../../types/EnrollLearners'
import { convertToDate } from '@/lib/dateConversions'
import React from 'react'

function InstructorEventDate({
  event,
  className = '',
}: {
  event: Instructorevents
  className?: string
}) {
  let locale = 'en-US'
  if (typeof navigator !== 'undefined' && navigator.language) {
    try {
      new Intl.DateTimeFormat(navigator.language)
      locale = navigator.language
    } catch {}
  }

  const startDateTime = convertToDate(
    event.event_date,
    event.event_start_time,
    event.event_timezone
  )
  const endDateTime = convertToDate(
    event.event_date,
    event.event_end_time,
    event.event_timezone
  )

  const timeFormatOptions: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  }

  const startFormatted = startDateTime.toLocaleTimeString(
    locale,
    timeFormatOptions
  )

  const endFormatted = endDateTime.toLocaleTimeString(
    locale,
    timeFormatOptions
  )

  return (
    <p className={`font-normal text-grays-dark ${className}`}>
      <span className="text-black">
        {' '}
        {startDateTime.toLocaleDateString(locale)}{' '}
      </span>{' '}
      | {startFormatted} - {endFormatted}
    </p>
  )
}

export default InstructorEventDate
